import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  ModalTrigger,
  Button,
  ButtonCommonTheme,
  FormGroup,
  FormControl,
  ControlLabel,
} from 'modules/theme';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';

import { FormWrapper, FormColumn } from 'modules/theme';
import { ModalFooter } from 'modules/theme';
import APIManager from 'modules/common/apiManager';
import { Alert } from 'modules/theme';

const contextTypes = {
  __: PropTypes.func,
};

const ImportTriggerFormWrapper = styled.div`
  height: 100%;
`;
class importFile extends Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.importFile = this.importFile.bind(this);
    this.mAPI = new APIManager();
    this.state = {
      showHide: false,
      file: null,
      loading: false,
    };
  }

  componentWillUnmount() {
    // this.props.clearState();
  }

  closeModal(isUpdated) {
    if (isUpdated && this.props.importDone) {
      this.props.importDone();
    }
    this.setState({ showHide: false, file: null });
  }
  openModal() {
    this.setState({ showHide: true });
  }
  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required || props.lableRequired}>
          {label}
        </ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }
  apiResponse(errorCode, data) {
    if (errorCode === 0 && errorCode === 200) {
      let message = 'File Successfully Updated.';
      message = data && data.message ? data.message : 'Successfully updated';
      Alert.success(`${message}`);
      this.closeModal();
    } else {
      let message =
        data && data.message ? data.message : 'Something wrong happened';
      Alert.error(`${message}`);
    }
  }
  importFile(e) {
    let _this = this;
    this.setState({ loading: true });
    const { apiUrl = '', fetchData } = this.props;
    let formData = fetchData(this.state.file);

    if (this.state.file) {
      this.mAPI.sendPostForm(
        `${apiUrl}`,
        formData,
        (data) => {
          this.setState({ loading: false });
          //Set the progress value to show the progress bar
          if (data.unsuccessRecord && data.unsuccessRecord.length > 0) {
            Alert.error(
              `Not all of the modifications you requested have been created/updated. For more information, please see the import and export logs.`
            );
          } else {
            Alert.success(`File is added.`);
          }
          this.closeModal(true);
          // this.handleModalShowImport();
          // this.resetAllData();
          // this.getList();
        },
        (errorCode, data) => {
          this.setState({ loading: false });
          this.apiResponse(errorCode, data);
        }
      );
    } else {
      Alert.error('Enter File...');
      this.setState({ loading: false });
    }
  }
  render() {
    const { __ } = this.context;
    const {
      buttonTitle = 'Import',
      title = 'Import',
      modalType = 'mid',
      fileAccept = '.csv',
      urlDownload = '',
      children
    } = this.props;
    const importTrigger = (
      <Button
        className='lightbutton-btn'
        btnStyle='default'
        size='small'
        //icon="upload-6"
        style={{ marginLeft: '10px' }}
      >
        <span
          className='material-symbols-outlined'
          style={{ lineHeight: '21px' }}
        >
          publish
        </span>
        {/* <BsBoxArrowInDown /> */}
        <span className="remove-text-on-925px" style={{ lineHeight: '21px' }}>{buttonTitle}</span>
      </Button>
    );
    return (
      <ModalTrigger
        title={title}
        trigger={importTrigger}
        size={modalType}
        showHide={this.state.showHide}
        closeModal={this.closeModal}
        openModal={this.openModal}
        // dialogClassName={modalType}
        dialogClassName={'import-trigger-dialog-classname'}
      >
        <ImportTriggerFormWrapper className='neodiv'>
          <FormWrapper className='import-trigger-form-wrapper px-5 pt-5'>
            <FormColumn style={{ width: '100%' }}>
              {this.renderFormGroup('File', {
                defaultValue: '',
                componentClass: 'file',
                lableRequired: true,
                type: 'file',
                value: '',
                accept: fileAccept,
                selectedFile: this.state.file,
                //title: '&nbsp;',
                onChange: (e) => {
                  if (e.target.files && e.target.files[0]) {
                    this.setState({ file: e.target.files[0] });
                  } else {
                    this.setState({ file: null });
                  }
                },
                id: 'file',
              })}
            </FormColumn>
          </FormWrapper>
          {children}
          <ModalFooter>
            {urlDownload && <div style={{ textAlign: 'left', marginBottom: '15px' }}>
              <Button
                btnStyle='link'
                size='small'
                icon='folder-download'
                target='_blank'
                href={this.mAPI.downloadUrl(`${urlDownload}`)}
                style={{
                  fontFamily: 'Nunito',
                  fontWeight: 500,
                  fontSize: '14px',
                  lineHeight: '21px',
                  color: '#4860D9',
                  paddingLeft: '0px',
                }}
              >
                {'Download Sample File'}
              </Button>
            </div>}
            <ButtonCommonTheme
              type='greyModalBtn'
              OnClick={() => this.closeModal()}
            >
              Cancel
            </ButtonCommonTheme>
            <ButtonCommonTheme
              type='blueModalBtn'
              disabled={this.state.loading}
              OnClick={() => this.importFile()}
            >
              Save
            </ButtonCommonTheme>
          </ModalFooter>
        </ImportTriggerFormWrapper>
      </ModalTrigger>
    );
  }
}

importFile.contextTypes = contextTypes;

export default importFile;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/ImportFile.js